import { AGENCY_POSTING_INIT_LOADING, AGENCY_POSTING_INIT_SUCCESS, AGENCY_POSTING_INIT_FAIL } from '@/store/types'

export const post = {
  [AGENCY_POSTING_INIT_LOADING](state) {
    state.posting.init = 0
    state.posting.initErr = []
    state.posting.menu = {}
  },
  [AGENCY_POSTING_INIT_SUCCESS](state, data) {
    state.posting.init = 1
    state.posting.initErr = []
    state.posting.menu = data.menu
  },
  [AGENCY_POSTING_INIT_FAIL](state, error) {
    state.posting.init = 2
    state.posting.initErr = error
    state.posting.menu = {}
  }
}
